import api from './api';
import { Empresa } from '../types';

export interface EmpresaDetalleResponse {
  empresa: Empresa;
  users: Array<{
    _id: string;
    email: string;
    nombre: string;
    role: string;
    activo: boolean;
    empresaId?: string;
  }>;
}

export const getEmpresas = () => api.get<Empresa[]>('/empresas');
export const getEmpresa = (id: string) => api.get<EmpresaDetalleResponse>(`/empresas/${id}`);
export const createEmpresa = (data: Partial<Empresa> & { sucursales?: string[] }) =>
  api.post<Empresa>('/empresas', data);
export const updateEmpresa = (id: string, data: Partial<Empresa> & { sucursales?: string[] }) =>
  api.patch<Empresa>(`/empresas/${id}`, data);
export const deleteEmpresa = (id: string) => api.delete(`/empresas/${id}`);

export const assignUserToEmpresa = (empresaId: string, userId: string) =>
  api.post(`/empresas/${empresaId}/users/${userId}`);

export const unassignUserFromEmpresa = (empresaId: string, userId: string) =>
  api.delete(`/empresas/${empresaId}/users/${userId}`);
